import { endOfDay, startOfDay } from "date-fns";
import { CaseFilterGroup } from "@/Pages/Cases/filtering/CaseFilterGroup";
import type { DateRangeFilter, Filter, FilterSet } from "@/Pages/Cases/filtering/filters/CaseFilter";

export const createFilterSetForDay = (date: Date, fields: Filter[]): FilterSet => {
  return {
    filters: fields.map(
      (filter) =>
        ({
          ...filter,
          group: CaseFilterGroup.byDate,
          from: startOfDay(date).toISOString(),
          to: endOfDay(date).toISOString(),
        }) as DateRangeFilter,
    ),
  };
};
